import React from 'react';

// @mui
import { TableCell, Tooltip } from '@mui/material';
import { fDateTime } from '../../utils/formatTime';
import i18n from '../../i18n';

export default class GridCreateModifyCell extends React.Component {
    render() {
        const { row, field } = this.props;
        const elements = Array.isArray(field?.elements) ? field.elements : [];
        const firstKey = elements[0] || null;
        const secondKey = elements[1] || null;

        let firstValue = null;
        let secondValue = null;

        if (firstKey && secondKey) {
            firstValue = row[firstKey] || null;
            secondValue = row[secondKey] || null;
        }


        const baseStyle = this.props.styles;


        return (
            <TableCell key={field.id} align="left" sx={{ gap: 1, ...baseStyle }}>
                {firstValue && secondValue ? (
                    <div>
                        <Tooltip title={i18n.t(`columns.${firstKey}`)} placement="top-start">
                            <p>{fDateTime(firstValue, 'd MMM yyyy HH:mm')} </p>
                        </Tooltip>
                        <Tooltip title={i18n.t(`columns.${secondKey}`)}>
                            <p>{fDateTime(secondValue, 'd MMM yyyy HH:mm')} </p>
                        </Tooltip>
                    </div>
                ) : (
                    <div> — </div>
                )}

            </TableCell>
        );
    }
}
